import { render, staticRenderFns } from "./DocumentosEvento.vue?vue&type=template&id=62ef87b9"
import script from "./DocumentosEvento.vue?vue&type=script&lang=js"
export * from "./DocumentosEvento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports